import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const useQuery = () => new URLSearchParams(useLocation().search);
export const useQueryWithSearch = (search) => new URLSearchParams(search);
export const useQueryString = () => queryString.parse(useLocation().search);

export default useQuery;
